import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core';

@Pipe({
	name: 'numberToDecimalStr',
})
export class NumberToDecimalStrPipe implements PipeTransform {
	constructor(@Inject(LOCALE_ID) private readonly locale: string) {}

	transform(value: number): string {
		return new Intl.NumberFormat(this.locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(value);
	}
}
